import { withNodeResizable } from '../shared/NodeResizable';
import { Portal } from '../shared/Portal';
import { createEmbedExtension } from '../shared/createEmbedExtension';
import { EmbedRendererProps } from '../shared/types';

const URL_REGEX = new RegExp(
  'https://([w.-]+.)?figma.com/(file|proto)/([0-9a-zA-Z]{22,128})(?:/.*)?$',
);
export const ENABLED = [URL_REGEX];

export const Component = ({ url, ...rest }: EmbedRendererProps<any>) => (
  <Portal
    {...rest}
    url={`https://www.figma.com/embed?embed_host=outline&url=${url}`}
    title="Figma Embed"
    fullHeight
  />
);

export default createEmbedExtension({
  regexp: [URL_REGEX],
  name: 'figma-embed',
  component: withNodeResizable(Component, {
    lockAspectRatio: false,
    defaultHeight: 500,
  }),
  addCommandOption: {
    title: 'Figma',
    description: 'Embed a Figma.',
    searchTerms: ['embed', 'figma'],
    icon: 'tabler:brand-figma',
  },
});
